import { defineMessages } from 'react-intl';

export default defineMessages({
  offline: {
    id: 'ReactFilters.messages.attendanceMode.offline',
    defaultMessage: 'In situ',
  },
  online: {
    id: 'ReactFilters.messages.attendanceMode.online',
    defaultMessage: 'Online',
  },
  mixed: {
    id: 'ReactFilters.messages.attendanceMode.mixed',
    defaultMessage: 'Mixed',
  },
});
